module.exports = "#version 300 es\r\nprecision highp float;\r\n\r\n// The vertex shader used to render the background of the scene\r\n\r\nin vec4 vs_Pos;\r\nout vec2 fs_Pos;\r\n\r\nvoid main() {\r\n  fs_Pos = vs_Pos.xy;\r\n  gl_Position = vec4(vs_Pos.xy, 0.999, 1.0);\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/flat-bg-vert.glsl
// module id = 79
// module chunks = 0